import React from "react";
import styled from "@emotion/styled";
import { Link, useLocation } from "react-router-dom";
import { SMALL_DEVICES } from "../../mediaQueries";

const Container = styled.span`
  text-transform: uppercase;
  font-size: 24px;
  color: white;
  cursor: pointer;
  user-select: none;
  border-bottom: 1px solid transparent;
  transition: color 0.3s, border-color 0.3s;

  &:hover {
    color: #85d3e0;
  }

  &.selected {
    color: #85d3e0;
    border-color: #85d3e0;
  }

  ${SMALL_DEVICES} {
    font-size: 4vw;
  }
`;

interface Props {
  label: string;
  path: string;

  isSelected?: boolean;
}

export const NavItem: React.FC<Props> = (props) => {
  const location = useLocation();
  const isSelected = props.isSelected || location.pathname === props.path;
  return (
    <Link to={props.path}>
      <Container className={isSelected ? "selected" : ""}>
        {props.label}
        {props.children}
      </Container>
    </Link>
  );
};
